/*
*###############################################################################
*Module Name                   : DPAniversaryBox.js                            #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  I Dinisuru blasuriya                         #
*Date                          : Thursday, September 23rd 2021, 10:20:22 am    #
*Copyright (c) 2021 myPOS Software Solution (pvt Ltd.)                         #
*###############################################################################
*/

import React, { useState } from 'react';
import {Row,Label,Input } from "reactstrap"


const DPAniversaryBox = ({rowClass,labelText,textType,mmValue,mmonChange,mmplaceholder,textAlign,disabled,mmonKeyPress,mmonBlur,ddvalue,ddonChange,ddonKeyPress,ddonBlur,ddplaceholder}) => {
    return (
        <Row className={rowClass}>
            <Label
                htmlFor="example-text-input"
                className="col-md-3 col-form-label-sm"
            >
                {labelText}
            </Label>
            <div className="col-md-4">
                <Input
                    className="form-control-sm"
                    type={textType}
                    value={mmValue}
                    onChange={mmonChange}
                    onKeyPress={mmonKeyPress}
                    onBlur={mmonBlur}
                    placeholder={mmplaceholder}
                    style={ {textAlign: textAlign ?  textAlign :'left',}}
                    disabled={disabled}
                />
            </div>
            <div className="col-md-1">
            <Label
             htmlFor="example-text-input"
             className="col-md-3 col-form-label-sm"
             style={{textAlign:"right"}}>
                /
            </Label>
            </div>
            <div className="col-md-4">
                <Input
                    className="form-control-sm"
                    type={textType}
                    value={ddvalue}
                    onChange={ddonChange}
                    onKeyPress={ddonKeyPress}
                    onBlur={ddonBlur}
                    placeholder={ddplaceholder}
                    style={ {textAlign: textAlign ?  textAlign :'left',}}
                    disabled={disabled}
                />
            </div>
        </Row>
    );
}

export default DPAniversaryBox;